import useAuthSystem from '../new_arch/modules/authentication/system/useAuthSystem';

export const useIsGuest = () => {
	const authSystem = useAuthSystem();
	return authSystem.isGuest;
}
